import { motion } from 'framer-motion';
import { FaCalendarAlt } from 'react-icons/fa';
import { stackedAnimInitial } from '../../constants/animationVariants';

const Notification = () => {
  // rendering notification component here
  return (
    <motion.div
      initial={stackedAnimInitial}
      className='notification flex flex-col md:flex-row gap-3 items-center bg-base-white rounded-xl shadow-academia-sm p-3 border-t-[5px] md:border-t-0 md:border-l-[5px] border-base-cyan'
    >
      <div>
        <FaCalendarAlt className='size-12 text-base-cyan' />
      </div>

      <div className='text-center md:text-left'>
        <h2 className='text-lg font-medium text-base-cyan'>
          Appointment Reminder
        </h2>
        <p>
          You have an appointment with Mr. Milhan{' '}
          <span className='text-base-purple font-medium'>@12:00 PM</span>
        </p>
      </div>
    </motion.div>
  );
};

export default Notification;
